/**
 * drag-zoom-wrapper
 *
 * Deliberately inert.
 *
 * This used to implement per-frame pinch and pan inside the PDP zoom
 * overlay: it scaled one image within its own box. That is the wrong model
 * for this gallery — the overlay is one continuous column of frames, and
 * magnifying should magnify the whole column (as therow.com does), not a
 * single frame floating in white space.
 *
 * It also called preventDefault() on every touchstart and touchmove, so the
 * browser never received a scroll gesture and the column could not be
 * scrolled at all.
 *
 * Zoom is now the browser's own pinch-zoom, which magnifies and pans the
 * whole overlay for free. The viewport meta in snippets/meta-tags.liquid is
 * `width=device-width, initial-scale=1` with nothing disabling user scaling,
 * so that is available to us.
 *
 * The element is still registered because <drag-zoom-wrapper> is rendered by
 * blocks/_product-media-gallery.liquid and should upgrade cleanly. The full
 * original implementation is preserved in the theme export at
 * theme_export__romanpell-com-fw26-update__05AUG2026-1203pm/assets/.
 */
export class DragZoomWrapper extends HTMLElement {}

if (!customElements.get('drag-zoom-wrapper')) {
  customElements.define('drag-zoom-wrapper', DragZoomWrapper);
}
